import * as React from 'react';
import { ComponentType } from 'react';
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import ReactTable, { RowInfo } from 'react-table';
import { bindActionCreators } from "redux";
import { InlineLoading } from 'src/components/common';
import { HrecsBreadcrumbs } from 'src/helpers/breadcrumbHelper';
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import * as HrecActions from '../../../actions/hrec';
import * as NavigationActions from '../../../actions/navigation';
import * as PagingActions from '../../../actions/pages/pagingPage';
import { FormFilterInput } from '../../../components/form';
import { RestrictedLayout } from "../../../components/layouts/index";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { IFormFilter, ITmdState } from "../../../reducers/index";

import './HrecsPage.scss';

interface IHrecsPageParams {}

interface IHrecsPageProps extends IRouterProps<IHrecsPageParams> {

    // From state
    formFilter: IFormFilter;
    formLength: number;
    hrecs: Dtos.Hrec[];
    loadingHrecs: boolean;
    loadHrecsSuccess: boolean;
    loadHrecsFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    lookups: Dtos.Lookup[];

    pageSize: number;
}

interface IHrecsPageActions extends IRouterActions {
    clearHrecs: HrecActions.IHrecClearActionCreator;
    loadHrecs: HrecActions.IHrecLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: HrecActions.IHrecFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

type HrecsPageProps = IHrecsPageProps & IHrecsPageActions;

class HrecsPage extends React.PureComponent<HrecsPageProps, any> {

    constructor(props: HrecsPageProps) {
        super(props);

        this.clearHrecs = this.clearHrecs.bind(this);

        this.state = {
            exportToggle: false
        };
    }

    componentDidMount() {
        const {
            loadHrecs,
            setBreadcrumbs,
            setDrawerItems
        } = this.props;
        

        loadHrecs();

        setDrawerItems([]);
        setBreadcrumbs(HrecsBreadcrumbs());
    }

    componentWillReceiveProps(_nextProps: HrecsPageProps) {
    }

    componentDidUpdate(_prevProps: HrecsPageProps, _prevState) {
    }

    componentWillUpdate(_nextProps: HrecsPageProps) {
    }

    componentWillUnmount() {
        this.clearHrecs();
    }

    clearHrecs() {
        this.props.clearHrecs();
    }

    showHrecs(): boolean {
        const {
            loadingHrecs,
            loadHrecsSuccess
        } = this.props

        if (!loadingHrecs && loadHrecsSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingHrecs
        } = this.props;

        return (
            <RestrictedLayout
                anyMatchpermission={Dtos.Permission.HrecView}
                loading={loadingHrecs}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        const canCreate = AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HrecCreate);

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>HREC Manager</h1>
                    </div>
                    <div className="col d-flex justify-content-end align-items-stretch" style={{ height: '38px' }}>
                        <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />

                        {canCreate && 
                            <>
                                <Link className={"btn btn-primary"} url={"/settings/hrecs/create"}>Create</Link>
                            </>
                        }
                    </div>
                </div>
                {
                    !this.showHrecs() ?
                        <InlineLoading absoluteCenter={true} size={50}/> :
                        null
                }
                {
                    this.showHrecs() ?
                        <div className='card'>
                            <div className="patient-tables">
                                {
                                    this.createTable()
                                }
                            </div>
                        </div> :
                        null
                }
            </div>
        );
    }

    createTable() {

        const {
            hrecs,
            pageSize,
            setPageSize,
            permissions
        } = this.props

        if (!hrecs || hrecs.length == 0) {
            return (
                <div className='card card-shadow p-3'>
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>There are currently no HRECs to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = hrecs.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={hrecs}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={showPagination ? pageSize : hrecs.length}
                    pageSize={showPagination ? pageSize : hrecs.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no HRECs to display"
                    resizable={false}
                    onPageSizeChange={val => setPageSize(val)}
                    getTdProps={(state, rowInfo: RowInfo, _column, _instance) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const HrecId = rowInfo.original.id;
                                const canView = AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HrecView, HrecId, undefined);
                                if (canView){
                                    const url: string = "/settings/hrecs/" + rowInfo.original.id + "/details";
                                    this.props.navigate(url);
                                }

                                if (handleOriginal) {
                                    handleOriginal()
                                }

                            }
                        }
                    }}
                    defaultSorted={[
                        {
                            id: "fullName",
                            desc: false
                        }
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: ' ',
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => <FontAwesomeIcon size='lg' icon={FontAwesomeIcons.Duotone.HANDHOLDINGHEART} fixedWidth />
                        },
                        {
                            id: "fullName",
                            Header: 'Name',
                            accessor: 'fullName',
                            Cell: (props) => <span>{props.value ?? props?.original?.fullName}</span>
                        },
                        {
                            id: "hrecNo",
                            Header: 'No.',
                            accessor: 'hrecNo',
                            maxWidth: 120
                        },
                        {
                            id: "administrator.displayWithSalutation",
                            Header: "Administrator",
                            accessor: "administrator.displayWithSalutation",
                            maxWidth: 300,
                            Cell: (props) => <span>{`${props?.original?.administrator?.lastName ? props?.original?.administrator?.lastName + ',' : ''} ${props?.original?.administrator?.salutation?.value ?? ''} ${props?.original?.administrator?.firstName ?? ''}`}</span>
                        }
                    ]}
                />
            </div>
        );
    }

}

const mapStateToProps = (state: ITmdState, ownProps: HrecsPageProps): IHrecsPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: ownProps.location,
        match: ownProps.match,

        hrecs: state.hrecs.formFilteredData!,
        formFilter: state.hrecs.formFilter,
        formLength: state.hrecs.formLength,
        lookups: state.hrecs.lookups,

        loadingHrecs: state.hrecs.loadState && state.hrecs.loadState.status == RequestState.Pending,
        loadHrecsSuccess: state.hrecs.loadState && state.hrecs.loadState.status == RequestState.Success,
        loadHrecsFailure: state.hrecs.loadState && state.hrecs.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,

        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch, ownProps: HrecsPageProps): IHrecsPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadHrecs: bindActionCreators(HrecActions.LoadHrec, dispatch),
        clearHrecs: bindActionCreators(HrecActions.Clear, dispatch),

        filter: bindActionCreators(HrecActions.Filter, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default
    RouterHoc<IHrecsPageParams, HrecsPageProps>((connect(mapStateToProps, mapDispatchToProps)(HrecsPage) as unknown as ComponentType<HrecsPageProps>)) as ComponentType<any>;
